<template>
    <div style="position: relative">
        <swiper
            :slides-per-view="3"
            :space-between="30"
            :breakpoints="{
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 4,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 5,
                  spaceBetween: 50,
                },
            }"
            :loop="false"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
            :key="data_key"
        >
            <swiper-slide
                    v-for="badge in data"
                    :key="badge.id"
            >
                <div class="text-center hero-badge" style="height:  160px; width: 160px">
                    <div v-if="badge.achievement.deck_count > 1" class="hero-badge__counter"><span>{{ badge.achievement.deck_count }}x</span></div>
                    <img style="object-fit: contain; width: 136px; height: 136px" :src="badge.achievement.image" :alt="badge.achievement.title">
                    <div class="badge-ribbon">
                        <div class="badge-ribbon__title">{{badge.achievement.title}}</div>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
import { Navigation, Pagination } from 'swiper'

import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'

// Import Swiper styles
import 'swiper/swiper-bundle.css'

SwiperCore.use([Navigation, Pagination])

export default {
  name: 'SwiperBadges',
  props: ['data', 'data_key'],
  components: {
    Swiper,
    SwiperSlide
  },
  methods: {
    onSwiper (swiper) {
    },
    onSlideChange () {
    }
  }
}
</script>

<style lang="scss" scoped>
.img-fluid {
  max-width: 100%;
  height: auto;
}
.w-100 {
  width: 100%;
}
.ml-auto, .mx-auto {
  margin-left: auto;
}
.mr-auto, .mx-auto {
  margin-right: auto;
}
</style>
